import { request } from '@umijs/max';
import { handleApiResponse } from '@/utils/errorHandler';
import { message } from 'antd';

const serviceApi = '/admin-api/system/auth';
const wecomServiceApi = '/admin-api/external/wecom';

// 登录
export const login = (body: any, options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${serviceApi}/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Tenant-Id': '1'
        },
        data: body,
        ...(options || {}),
    });
  };
  
  // 注册
  export const register = (body: any, options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${serviceApi}/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
  };
  
  // 登出
  export const outLogin = () => {
    return request<API.Result<any>>(`${serviceApi}/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    });
  };
  // 获取登录验证码
  export const sendSmsCode = (body: any, options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${serviceApi}/send-sms-code`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
  };
  
  // 短信验证码登录
  export const smsLogin = (body: any, options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${serviceApi}/sms-login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
  };

  // 企业微信授权登录
  export const wecomLogin = (body: any, options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${wecomServiceApi}/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
  };

  // 获取企业微信配置信息
  export const getWecomConfig = (options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${wecomServiceApi}/config`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        ...(options || {}),
    });
  };
  export const generateAuthUrl = (options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${wecomServiceApi}/generateAuthUrl`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        ...(options || {}),
    });
  };
  
  // 获取企业微信JSSDK配置信息
  export const getWecomJssdkConfig = (body: any, options?: { [key: string]: any }) => {
    return request<API.Result<any>>(`${wecomServiceApi}/jssdk-config`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
  };
  
  /** 获取当前的用户 GET /api/currentUser */
  export async function currentUser(options?: { [key: string]: any }) {
    return request<{
      data: any;
    }>('/admin-api/system/auth/get-permission-info', {
      method: 'GET',
      ...(options || {}),
    });
  }